import React from 'react';
//import FontAwesome from 'react-fontawesome';
// import * as CardComponents from '../../../Common/CardComponents';
import {ProfileThumb} from '../../../Common/CardComponents';
import AuthorFollowButton from '../../../Author/AuthorFollowButton';
// import {mobileCheck} from '../../../../helpers';
import { translate } from 'react-i18next';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import cx from '../../../../styles';

const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    centerPadding: '50px'
};

const UserFollowSuggestions = ({elems=[], t}) => {
    return (
        <div className={cx("user-follow-suggestions")}>
            <div className={cx("header-wrap")}>
                <div>{t('home_people_you_can_follow')}</div>
            </div>
            <Slider {...settings}>
                {
                    elems.map((user, i) => {
                        let tagline;
                        if(user.tagline && user.tagline.length > 20) {
                            tagline = user.tagline.slice(0, 20) + " ...";
                        } else if(user.tagline && user.tagline.length <= 20) {
                            tagline = user.tagline;
                        } else {
                            tagline = "Trying to be happy ...";
                        }
                        //console.log(user);
                        return (
                            <div key={i} className={cx("card-wrap")}>
                                <div className={cx("shadow-card")}>
                                    <div className={cx("user-follow-detail")}>
                                        <a href={'/' + user.slug} rel="nofollow">
                                            <ProfileThumb img={user.image ? user.image : ""} size="xlarge" altName={`${user.fullname} profile icon`} />
                                        </a>
                                        <div className={cx("profile-name")}>
                                            <a href={'/' + user.slug} rel="nofollow"><div>{user.fullname}</div></a>
                                        </div>
                                        <div className={cx("")}>
                                            { tagline }
                                        </div>
                                    </div>

                                    <div>
                                        <AuthorFollowButton author={user} />
                                    </div>
                                </div>
                            </div>
                        );
                    })
                }
            </Slider>
        </div>
    );
}

export default translate()(UserFollowSuggestions);
